// utils/API/BackendHelper/COLLEGES/student.js

import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class CollegeDegreeHelper {
  /**
   * Fetch all Degrees offered By a COLLEGE
   * @param {Object} params - Query parameters (page, limit, search, etc.)
   * @returns {Promise} API response
   */
  async getDegreesOffered(collegeId, params = {}) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.COLLEGES.OFFERED_DEGREES(collegeId), params);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch degrees: ${error.message}`);
    }
  }

}

export default new CollegeDegreeHelper();